import type {
  ActionsEnumKey,
  GetBrokerageFirmOutputFirmTypeEnumKey,
  PolicyDtoStatusEnumKey,
} from 'korint-sdk';
import type { PolicyQuickAction, PolicyQuickActionEntity } from 'korint-sdk/react';

type Visibility = {
  productId: string;
  status: PolicyDtoStatusEnumKey;
  can: Partial<Record<ActionsEnumKey, boolean>>;
  declaredPolicyEvents: ReadonlyArray<string>;
  firmType?: GetBrokerageFirmOutputFirmTypeEnumKey;
  isSuperUser?: boolean;
};

const editPermissionByEntity: Record<PolicyQuickActionEntity, ActionsEnumKey> = {
  policy: 'EDIT_POLICY',
  asset: 'EDIT_ASSET',
  customer: 'EDIT_CUSTOMER',
};

const requiredPermissions = (action: PolicyQuickAction): ReadonlyArray<ActionsEnumKey> => {
  if (action.type === 'publishEvent') {
    return ['PUSH_POLICY_EVENT'];
  }
  if (action.type === 'updateField') {
    return [editPermissionByEntity[action.entity]];
  }

  return action.requiredActions ?? [];
};

export function getVisibleQuickActions(
  actions: ReadonlyArray<PolicyQuickAction> = [],
  { productId, status, can, declaredPolicyEvents, firmType, isSuperUser }: Visibility,
): PolicyQuickAction[] {
  return actions.filter(action => {
    if (action.forProducts && !action.forProducts.includes(productId)) {
      return false;
    }
    if (action.forStatuses && !action.forStatuses.includes(status)) {
      return false;
    }
    if (
      action.forFirmTypes &&
      !isSuperUser &&
      !(firmType && action.forFirmTypes.includes(firmType))
    ) {
      return false;
    }
    if (!requiredPermissions(action).every(permission => can[permission])) {
      return false;
    }
    // An event absent from the product's customEvents.policy is rejected by the backend.
    if (action.type === 'publishEvent' && !declaredPolicyEvents.includes(action.eventType)) {
      return false;
    }

    return true;
  });
}
